import { Dispatch, FunctionComponent, useEffect } from 'react';
import { VoucherCheckoutState } from '../vouchersState';
import { FormContext, TextField, useForm } from '@cademy-ui/form';
import { AmountSelector } from './components/AmountSelector';
import { SharingMethodSelector } from './components/SharingMethodSelector';
import Button from '../../../../components/Button';
import styles from './styles.module.scss';

export const RecipientDetails: FunctionComponent<{
    state: VoucherCheckoutState;
    dispatch: Dispatch<Partial<VoucherCheckoutState>>;
}> = ({ state, dispatch }) => {
    const formContext = useForm({
        initialValues: {
            recipientFirstName: '',
            recipientEmail: '',
            message: '',
            sharingMethod: 'email',
        },
        requiredStrategy: 'required',
        onSubmit: async (formResponse) => {
            dispatch({ currentStep: 'buyerDetails' });
        },
    });

    useEffect(() => {
        if (
            state.recipient.firstName === formContext.values.recipientFirstName &&
            state.recipient.email === formContext.values.recipientEmail &&
            state.message === formContext.values.message &&
            state.sharingMethod === formContext.values.sharingMethod
        ) {
            return;
        }

        dispatch({
            recipient: {
                ...state.recipient,
                firstName: formContext.values.recipientFirstName,
                email: formContext.values.recipientEmail,
            },
            message: formContext.values.message,
            sharingMethod: (formContext.values.sharingMethod as 'email' | 'pdf') || 'email',
        });
    }, [state, dispatch, formContext.values]);

    return (
        <FormContext.Provider value={formContext}>
            <div>
                <div>
                    <h3>Select gift amount</h3>
                    <AmountSelector state={state} dispatch={dispatch} />
                </div>

                <h3 className="mt-20">Personalise your gift</h3>
                <div>
                    <TextField
                        label="Recipient Name"
                        name="recipientFirstName"
                        autoComplete="off"
                        required
                    />
                </div>
                <div>
                    <TextField
                        label="Message"
                        name="message"
                        autoComplete="off"
                        description="Enter an optional message"
                    />
                </div>

                <h3>How do you want to share this gift?</h3>
                <SharingMethodSelector state={state} dispatch={dispatch} />

                <div className={styles.continueButtonContainer}>
                    <Button onClick={formContext.submit} preset="primary">
                        Continue
                    </Button>
                </div>
            </div>
        </FormContext.Provider>
    );
};
